const blank = (value) => !String(value ?? "").trim();

export function validateEventForm(form, imageFile) {
  const errors = {};
  if (blank(form.name) || String(form.name).trim().length < 2) errors.name = "Informe um nome com pelo menos 2 caracteres.";
  if (!form.startsAt) errors.startsAt = "Informe a data e a hora de início do evento.";
  if (!form.registrationStartsAt) errors.registrationStartsAt = "Informe a data de início das inscrições.";
  if (!form.registrationEndsAt) errors.registrationEndsAt = "Informe a data final das inscrições.";

  const startsAt = form.startsAt ? new Date(form.startsAt) : null;
  const endsAt = form.endsAt ? new Date(form.endsAt) : null;
  const registrationStartsAt = form.registrationStartsAt ? new Date(`${form.registrationStartsAt}T00:00:00`) : null;
  const registrationEndsAt = form.registrationEndsAt ? new Date(`${form.registrationEndsAt}T23:59:59.999`) : null;
  if (startsAt && endsAt && endsAt < startsAt) errors.endsAt = "O fim do evento deve ser posterior ao início.";
  if (registrationStartsAt && registrationEndsAt && registrationEndsAt < registrationStartsAt) errors.registrationEndsAt = "O fim das inscrições deve ser posterior ao início.";
  if (startsAt && registrationEndsAt && registrationEndsAt > startsAt) errors.registrationEndsAt = "As inscrições devem terminar até o início do evento.";

  const price = Number(form.basePrice);
  if (blank(form.basePrice) || !Number.isFinite(price) || price < 0) errors.basePrice = "Informe um valor válido, igual ou maior que zero.";
  if (!blank(form.capacity)) {
    const capacity = Number(form.capacity);
    if (!Number.isInteger(capacity) || capacity <= 0) errors.capacity = "Informe uma quantidade inteira maior que zero ou deixe em branco.";
  }
  if (!Array.isArray(form.classrooms) || !form.classrooms.length) errors.classrooms = "Selecione ao menos uma turma participante.";

  const dueDates = Array.isArray(form.installmentDueDates) ? form.installmentDueDates : [];
  if (!dueDates.length || dueDates.length > 10) errors.installmentDueDates = "Informe entre 1 e 10 parcelas.";
  dueDates.forEach((date, index) => {
    const key = `installmentDueDates.${index}`;
    if (!date) errors[key] = `Informe o vencimento da parcela ${index + 1}.`;
    if (date && index && dueDates[index - 1] && date <= dueDates[index - 1]) errors[key] = "O vencimento deve ser posterior ao da parcela anterior.";
    if (date && startsAt && new Date(`${date}T23:59:59.999`) > startsAt) errors[key] = "A parcela deve vencer até o início do evento.";
  });

  if (imageFile && !["image/jpeg", "image/png"].includes(imageFile.type)) errors.imageFile = "Selecione uma imagem JPG ou PNG.";
  if (imageFile && imageFile.size > 5 * 1024 * 1024) errors.imageFile = "A imagem deve ter no máximo 5 MB.";
  return errors;
}

export function validatePaymentConfig(config) {
  const errors = {};
  if (!config?.environment) errors.environment = "Selecione o ambiente da conta.";
  if (blank(config?.accountHandle) || String(config.accountHandle).trim().length < 2) errors.accountHandle = "Informe a InfiniteTag da conta de Eventos.";
  return errors;
}

export function validateSchoolEnrollment(enrollmentStudent, classroom, responsibleName) {
  const errors = {};
  if (!enrollmentStudent) errors.student = "Pesquise e selecione um aluno.";
  if (enrollmentStudent && !classroom) errors.student = "Não foi encontrada uma turma participante para este aluno.";
  if (blank(responsibleName) || String(responsibleName).trim().length < 2) errors.responsibleName = "Informe o nome do responsável com pelo menos 2 caracteres.";
  return errors;
}

export function validateCashPayment(payment, pendingInstallments = 1) {
  const errors = {};
  if (blank(payment?.payerName) || String(payment.payerName).trim().length < 2) errors.payerName = "Informe o nome de quem realizou o pagamento.";
  if (!payment?.method) errors.method = "Selecione a forma de pagamento.";
  if (blank(payment?.transactionReference) || String(payment.transactionReference).trim().length < 3) errors.transactionReference = "Informe o código do recibo ou uma referência com pelo menos 3 caracteres.";
  if (blank(payment?.reason) || String(payment.reason).trim().length < 3) errors.reason = "Informe uma observação com pelo menos 3 caracteres.";
  const count = Number(payment?.installmentCount);
  const maximum = Math.min(10, Math.max(1, Number(pendingInstallments) || 1));
  if (!Number.isInteger(count) || count < 1 || count > maximum) errors.installmentCount = `Informe uma quantidade entre 1 e ${maximum}.`;
  return errors;
}

export const hasValidationErrors = (errors) => Object.keys(errors || {}).length > 0;
